import React from "react";
import { SLOResponse } from "@internal/plugin-ops-review-common";
import {
  Card,
  CardContent,
  CardHeader,
  makeStyles,
  Theme,
} from "@material-ui/core";

const useStyles = makeStyles((_theme: Theme) => ({
  header: {
    textAlign: "center",
  },
  content: {
    color: "white",
    fontWeight: "bold",
  },
  sliValue: {
    textAlign: "center",
    fontSize: "48px",
    fontWeight: "bold",
  },
  target: {
    textAlign: "center",
  },
}));

interface Props {
  sloHistory: SLOResponse;
  days: number;
}

export const SLOCard: React.FC<Props> = ({ sloHistory, days }): JSX.Element => {
  const classes = useStyles();

  let precision: number;
  let threshold: any;

  switch (days) {
    case 7: {
      precision = sloHistory.overall.precision["7d"];
      threshold = sloHistory.slo.thresholds.find((t: any) => {
        return t.timeframe === "7d";
      });
      break;
    }
    case 30: {
      precision = sloHistory.overall.precision["30d"];
      threshold = sloHistory.slo.thresholds.find((t: any) => {
        return t.timeframe === "30d";
      });
      break;
    }
    default: {
      precision = sloHistory.overall.precision.custom;
      threshold = sloHistory.slo.thresholds.find((t: any) => {
        return t.timeframe === "30d";
      });
    }
  }

  let background: string;

  if (threshold && threshold?.target) {
    background =
      sloHistory.overall.sli_value.toFixed(precision) >= threshold.target
        ? "#00AB66"
        : "red";
  } else {
    background = "gray";
  }

  return (
    <a
      href={`https://app.datadoghq.com/slo?timeframe=${days}d&slo_id=${sloHistory.slo.id}`}
      target="_blank"
    >
      <Card>
        <CardHeader title={`Past ${days} Days`} className={classes.header} />
        <CardContent
          style={{ backgroundColor: background }}
          className={classes.content}
        >
          <p className={classes.sliValue}>
            {sloHistory.overall.sli_value.toFixed(precision)}%
          </p>
          <p className={classes.target}>Target: {threshold.target_display}%</p>
        </CardContent>
      </Card>
    </a>
  );
};
